import Vue from 'vue';
import VueCompositionAPI, {
  computed,
  reactive,
} from '@vue/composition-api';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import ptbr from 'date-fns/locale/pt';

// We need to register it again because of Vue instance instantiation issues
Vue.use(VueCompositionAPI);

const state = reactive({
  currentRevenue: { total: 0, date: new Date() },
  storeSelected: {},
  storeSelectedCampaignResults: {},
  isCampaignDialogOpen: false,
  /**
   * @type {any}
   */
  currentCampaign: {},
});

export const useManagerDashboard = () => {
  const changeCurrentRevenue = (newRevenue) => {
    state.currentRevenue = newRevenue;
  };
  const changeStoreSelected = (newStore) => {
    state.storeSelected = newStore;
  };
  const toggleCampaignDialog = () => {
    state.isCampaignDialogOpen = !state.isCampaignDialogOpen;
  };
  const changeCurrentCampaign = (newCampaign) => {
    state.currentCampaign = newCampaign;
  };
  const changeStoreSelectedCampaignResults = (newStore) => {
    state.storeSelectedCampaignResults = newStore;
  };

  const formatDate = (d) => format(d, 'MMMM', {
    locale: ptbr,
  });

  const formatNumber = (num) => parseInt(num, 10).toLocaleString('pr-BR', { maximumFractionDigits: 0 });

  return {
    changeCurrentRevenue,
    currentRevenue: computed(() => state.currentRevenue),
    changeStoreSelected,
    storeSelected: computed(() => state.storeSelected),
    changeStoreSelectedCampaignResults,
    storeSelectedCampaignResults: computed(() => state.storeSelectedCampaignResults),
    toggleCampaignDialog,
    isCampaignDialogOpen: computed(() => state.isCampaignDialogOpen),
    changeCurrentCampaign,
    currentCampaign: computed(() => state.currentCampaign),
    formatNumber,
    formatDate,
    currentDate: computed(() => {
      const startMonth = startOfMonth(state.currentRevenue.date);
      const endMonth = endOfMonth(state.currentRevenue.date)
      const formatPTBR = (d) => format(d, 'DD MMMM YYYY', {
        timeZone: 'America/Sao_Paulo',
        locale: ptbr,
      });
      return `${formatPTBR(startMonth)} - ${formatPTBR(endMonth)}`;
    }),
    updatedAt: computed(() => {
      // date-fns not updated
      // Characters wrapped between two single quotes characters (') are escaped. Not Working.
      const today = new Date();
      return {
        date: format(today, 'DD/MM/YYYY'),
        hours: format(today, 'HH:mm'),
      };
    }),
  };
};
